import { useSelector } from 'react-redux';
import { RootState } from '../../../../stores';

const useCartCombinedPrice = () => {
  const { items } = useSelector((state: RootState) => state.cart);

  const totalPrice = items.reduce((total, item) => total + item.count * (item.price - item.discount), 0);

  const toppings = items
    .filter((item) => item.orderItemToppings !== undefined)
    .flatMap((item) => item.orderItemToppings || []);

  const totalToppingsPrice = toppings.reduce((total, topping) => total + topping.price * topping.count, 0);

  const combinedTotalPrice = totalPrice + totalToppingsPrice;

  return {
    combinedTotalPrice,
  };
};

export default useCartCombinedPrice;
